if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement{
        constructor(){
            super();

            this.endDate = new Date(this.dataset.endDate).getTime();

            this.day = 24 * this.hour;
            this.hour = 60 * this.minute;
            this.minute = 60 * this.second;
            this.second = 1000;

            this.daysEl = this.querySelector('[data-days]');
            this.hoursEl = this.querySelector('[data-hours]');
            this.hoursEl = this.querySelector('[data-hours]');
            this.minutesEl = this.querySelector('[data-minutes]');
            this.secondsEl = this.querySelector('[data-seconds]');

            this.startCountdown();
        }

        startCountdown() {
            // Update the countdown every second
            this.timerInterval = setInterval(() => {
                // Get the current date and time
                const now = new Date().getTime();

                // Calculate the remaining time
                const distance = this.endDate - now;

                // If the countdown is over, set all values to zero and clear the interval
                if (distance <= 0) {
                    clearInterval(this.timerInterval);
                    this.daysEl.textContent = '0';
                    this.hoursEl.textContent = '0';
                    this.minutesEl.textContent = '0';
                    this.secondsEl.textContent = '0';
                    this.setAttribute('aria-live', 'assertive');
                    this.setAttribute('aria-label', this.dataset.countdownTimerEndedText);
                    return;
                }

                // Calculate days, hours, minutes, and seconds
                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                this.daysEl.textContent = days;
                this.hoursEl.textContent = hours;
                this.minutesEl.textContent = minutes;
                this.secondsEl.textContent = seconds;

                // If the countdown is over, clear the interval
                if (distance < 0) {
                    clearInterval(this.timerInterval);
                }
            }, 1000); // Update every second
        }

        // Clean up the timer interval when the element is removed
        disconnectedCallback() {
            clearInterval(this.timerInterval);
        }
    }

    customElements.define("countdown-timer", CountdownTimer)
}